"use client";

import React, { ReactNode } from "react";

interface CompanyDetailRowProps {
  icon: ReactNode;
  label: string;
  value: string | number;
  /** Use colSpan2 for full-width rows like website */
  colSpan2?: boolean;
}

export const CompanyDetailRow = React.memo(function CompanyDetailRow({
  icon,
  label,
  value,
  colSpan2 = false,
}: CompanyDetailRowProps) {
  return (
    <div className={`flex items-start gap-2 ${colSpan2 ? "col-span-2" : ""}`}>
      <span className="text-gray-400 mt-0.5 flex-shrink-0 [&>svg]:w-4 [&>svg]:h-4">{icon}</span>
      <div className={`flex-1 min-w-0 ${colSpan2 ? "" : ""}`}>
        <div className="text-xs text-gray-500">{label}</div>
        <div className="text-gray-700 dark:text-gray-300 text-sm">{value}</div>
      </div>
    </div>
  );
});
